var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg086Telephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.71 8.71C8.89719 8.52128 9.00154 8.2658 9 8V4C9 3.44772 8.55228 3 8 3H4C3.44772 3 3 3.44772 3 4C3 13.3888 10.6112 21 20 21C20.5523 21 21 20.5523 21 20V16C21 15.4477 20.5523 15 20 15H16C15.7342 14.9985 15.4787 15.1028 15.29 15.29L13.29 17.29L13.22 17.38C10.3798 15.93 8.07003 13.6202 6.62 10.78L6.71 10.71L8.71 8.71ZM16.41 17H19V19C17.7058 18.912 16.4285 18.6566 15.2 18.24L16.41 17ZM5.79 8.8C5.36321 7.57289 5.09766 6.29553 5 5H7V7.59L5.79 8.8Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg086Telephone);
export default __webpack_public_path__ + "static/media/086-telephone.37944caa227d93e935859f54c07ffbff.svg";
export { ForwardRef as ReactComponent };